// extracted by mini-css-extract-plugin
module.exports = {"review":"Review_review__y5CWE","divider":"Review_divider__UrrX6","image_desc":"Review_image_desc__ham7S","listing":"Review_listing__qecS7"};